import { images } from '../../../Constants/ImageUrls';

export const paymentTypes = [
  images.phonepay,
  images.airtel,
  images.googlePlay,
  images.freeCharge,
  images.paytm,
  images.mobikwik,
  images.creditCard,
];

export const noCostEmiMinAmount = 4000;
export const payOnlineDiscountPercent = 5;
export const showPercentageDiscount = (cartProducts) => {
  // return getWebUserType() === "B";
  return cartProducts?.includes(2631) || cartProducts?.includes(2632);
};
